
import Login from "layouts/vendor/Login";
import Register from "layouts/vendor/Register";
import ForgotPassword from "layouts/vendor/ForgotPassword";
import ForgotPasswordConfirm from "layouts/vendor/ForgotPasswordConfirm";
import RegisterConfirmation from "layouts/vendor/RegisterConfirmation";
import TermsAndConditions from "layouts/vendor/TermsAndConditions";
import Icon from "@mui/material/Icon";
import ProtectedRoute from "./ProtectedRoute";

const VendorRoutes = [

  {
    type: "collapse",
    name: "Login",
    key: "login",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/vendor/login",
    component: <ProtectedRoute check="login"><Login /></ProtectedRoute>
  },
  {
    route: "/vendor/register",
    key: "register",
    component:  <ProtectedRoute check="login"><Register /></ProtectedRoute>
  },
  {
    route: "/vendor/forgotPassword",
    key: "forgotPassword",
    component: <ProtectedRoute check="login" ><ForgotPassword /></ProtectedRoute>
  },
  {
    route: "/vendor/forgotPasswordConfirm",
    key: "forgotPasswordConfirm",
    component: <ProtectedRoute check="login"><ForgotPasswordConfirm /></ProtectedRoute>
  },
  {
    route: "/vendor/registerConfirmation",
    key: "registerConfirmation",
    component: <ProtectedRoute check="login"><RegisterConfirmation /></ProtectedRoute>
  },
  {
    route: "/vendor/acceptTermsAndConditions",
    key: "acceptTermsAndConditions",
    component: <ProtectedRoute check="login"><TermsAndConditions /></ProtectedRoute>
  },
];

export default VendorRoutes;
